import React, { SVGProps } from 'react';

const CreditCard = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
   <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
   >
     <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3337 5.33333C15.3337 3.49238 13.8413 2 12.0003 2H4.00033C2.15938 2 0.666992 3.49238 0.666992 5.33333V10.6667C0.666992 12.5076 2.15938 14 4.00032 14H12.0003C13.8413 14 15.3337 12.5076 15.3337 10.6667V5.33333ZM12.0003 3.33333C13.1049 3.33333 14.0003 4.22876 14.0003 5.33333L2.00033 5.33333C2.00033 4.22876 2.89576 3.33333 4.00033 3.33333L12.0003 3.33333ZM2.00033 8L2.00033 10.6667C2.00033 11.7712 2.89576 12.6667 4.00033 12.6667H12.0003C13.1049 12.6667 14.0003 11.7712 14.0003 10.6667V8L2.00033 8Z"
      fill={props?.fill || "#141928"}
     />
   </svg>
  );
};

CreditCard.displayName = 'CreditCard';

export default CreditCard;